import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TimeField from 'react-simple-timefield';
import GetUploadImage from './getUploadImage';
import '../css_generales/getConfiguracionSucursal.css';
import 'whatwg-fetch';
class getConfiguracionGlobal extends Component {
  constructor(props){
    super(props);
    this.state = {
        uuid_sucursal:'',
        id_sucursales:this.props.id_sucursal,
        sucursales:'',
        ruc:'',
        direccion:'',
        telefono:'',
        lat:0,
        lon:0,
        activo:0,
        estado_activo:false,
        hora_apertura_1:'00:00',
        hora_apertura_2:'00:00',
        hora_apertura_3:'00:00',
        hora_apertura_4:'00:00',
        hora_apertura_5:'00:00',
        hora_apertura_6:'00:00',
        hora_apertura_7:'00:00',
        hora_cierre_1:'00:00',
        hora_cierre_2:'00:00',
        hora_cierre_3:'00:00',
        hora_cierre_4:'00:00',
        hora_cierre_5:'00:00',
        hora_cierre_6:'00:00',
        hora_cierre_7:'00:00',
        hora_apertura_1_2:'00:00',
        hora_apertura_2_2:'00:00',
        hora_apertura_3_2:'00:00',
        hora_apertura_4_2:'00:00',
        hora_apertura_5_2:'00:00',
        hora_apertura_6_2:'00:00',
        hora_apertura_7_2:'00:00',
        hora_cierre_1_2:'00:00',
        hora_cierre_2_2:'00:00',
        hora_cierre_3_2:'00:00',
        hora_cierre_4_2:'00:00',
        hora_cierre_5_2:'00:00',
        hora_cierre_6_2:'00:00',
        hora_cierre_7_2:'00:00',
        tiempo_aproximado:0,
        precio_delivery:0,
        id_tipo_precio:0,
        distancia:0,
        tipo_precio:[
          {
            "id_tipo_precio":1, "tipo_precio":"Default"
          },
          {
            "id_tipo_precio":2, "tipo_precio":"Precio 2"
          },
          {
            "id_tipo_precio":3, "tipo_precio":"Precio 3"
          },
          {
            "id_tipo_precio":4, "tipo_precio":"Precio 4"
          }
        ]
    }
    this.inputChangedHandlerText8 = this.inputChangedHandlerText8.bind(this);
  }

  cargar_informacion =()=>{
    const url= this.props.dir_url + "webapp/getDataInformacionSucursal";
    const token =  this.props.token
    const id_sucursales = this.state.id_sucursales
    var obj = { accion:'datainformacionsucursal', token,id_sucursales};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        let activo = false
        if(Number(data[0].msg[0].acivo)===1){
            activo=true
        }
        this.setState({
          uuid_sucursal:data[0].msg[0].uuid_sucursal,
          sucursales:data[0].msg[0].sucursales,
          ruc:data[0].msg[0].ruc,
          direccion:data[0].msg[0].direccion,
          telefono:data[0].msg[0].telefono,
          lat:data[0].msg[0].lat,
          lon:data[0].msg[0].lon,
          activo:data[0].msg[0].acivo,
          hora_apertura_1:data[0].msg[0].hora_apertura_1_,
          hora_apertura_2:data[0].msg[0].hora_apertura_2_,
          hora_apertura_3:data[0].msg[0].hora_apertura_3_,
          hora_apertura_4:data[0].msg[0].hora_apertura_4_,
          hora_apertura_5:data[0].msg[0].hora_apertura_5_,
          hora_apertura_6:data[0].msg[0].hora_apertura_6_,
          hora_apertura_7:data[0].msg[0].hora_apertura_7_,
          hora_cierre_1:data[0].msg[0].hora_cierre_1_,
          hora_cierre_2:data[0].msg[0].hora_cierre_2_,
          hora_cierre_3:data[0].msg[0].hora_cierre_3_,
          hora_cierre_4:data[0].msg[0].hora_cierre_4_,
          hora_cierre_5:data[0].msg[0].hora_cierre_5_,
          hora_cierre_6:data[0].msg[0].hora_cierre_6_,
          hora_cierre_7:data[0].msg[0].hora_cierre_7_,
          hora_apertura_1_2:data[0].msg[0].hora_apertura_1__2,
          hora_apertura_2_2:data[0].msg[0].hora_apertura_2__2,
          hora_apertura_3_2:data[0].msg[0].hora_apertura_3__2,
          hora_apertura_4_2:data[0].msg[0].hora_apertura_4__2,
          hora_apertura_5_2:data[0].msg[0].hora_apertura_5__2,
          hora_apertura_6_2:data[0].msg[0].hora_apertura_6__2,
          hora_apertura_7_2:data[0].msg[0].hora_apertura_7__2,
          hora_cierre_1_2:data[0].msg[0].hora_cierre_1__2,
          hora_cierre_2_2:data[0].msg[0].hora_cierre_2__2,
          hora_cierre_3_2:data[0].msg[0].hora_cierre_3__2,
          hora_cierre_4_2:data[0].msg[0].hora_cierre_4__2,
          hora_cierre_5_2:data[0].msg[0].hora_cierre_5__2,
          hora_cierre_6_2:data[0].msg[0].hora_cierre_6__2,
          hora_cierre_7_2:data[0].msg[0].hora_cierre_7__2,
          tiempo_aproximado:data[0].msg[0].tiempo_aproximado,
          precio_delivery:data[0].msg[0].precio_delivery,
          id_tipo_precio:data[0].msg[0].id_tipo_precio,
          distancia:data[0].msg[0].distancia,
          estado_activo:activo
        })
      }
    })
    .catch(console.log)
  }

  getUUIDS=(uuid_sucursal,id_item)=>{
    this.setState({
      uuid_sucursal
    }, ()=>{
      this.getGrabarInformacion()
    })
  }

  getGrabarInformacion =()=>{
    const url= this.props.dir_url + "webapp/getGrabarSucursal";
    const token =  this.props.token
    /********************************************/
    const uuid_sucursal = this.state.uuid_sucursal
    const sucursales = this.state.sucursales
    const ruc = this.state.ruc
    const direccion = this.state.direccion
    const telefono = this.state.telefono
    const activo = this.state.activo
    const hora_apertura_1 = this.state.hora_apertura_1
    const hora_apertura_2 = this.state.hora_apertura_2
    const hora_apertura_3 = this.state.hora_apertura_3
    const hora_apertura_4 = this.state.hora_apertura_4
    const hora_apertura_5 = this.state.hora_apertura_5
    const hora_apertura_6 = this.state.hora_apertura_6
    const hora_apertura_7 = this.state.hora_apertura_7
    const hora_cierre_1 = this.state.hora_cierre_1
    const hora_cierre_2 = this.state.hora_cierre_2
    const hora_cierre_3 = this.state.hora_cierre_3
    const hora_cierre_4 = this.state.hora_cierre_4
    const hora_cierre_5 = this.state.hora_cierre_5
    const hora_cierre_6 = this.state.hora_cierre_6
    const hora_cierre_7 = this.state.hora_cierre_7
    const hora_apertura_1_2 = this.state.hora_apertura_1_2
    const hora_apertura_2_2 = this.state.hora_apertura_2_2
    const hora_apertura_3_2 = this.state.hora_apertura_3_2
    const hora_apertura_4_2 = this.state.hora_apertura_4_2
    const hora_apertura_5_2 = this.state.hora_apertura_5_2
    const hora_apertura_6_2 = this.state.hora_apertura_6_2
    const hora_apertura_7_2 = this.state.hora_apertura_7_2
    const hora_cierre_1_2 = this.state.hora_cierre_1_2
    const hora_cierre_2_2 = this.state.hora_cierre_2_2
    const hora_cierre_3_2 = this.state.hora_cierre_3_2
    const hora_cierre_4_2 = this.state.hora_cierre_4_2
    const hora_cierre_5_2 = this.state.hora_cierre_5_2
    const hora_cierre_6_2 = this.state.hora_cierre_6_2
    const hora_cierre_7_2 = this.state.hora_cierre_7_2
    const tiempo_aproximado = this.state.tiempo_aproximado
    const precio_delivery = this.state.precio_delivery
    const id_tipo_precio = this.state.id_tipo_precio
    const distancia = this.state.distancia
    const id_sucursal =this.props.id_sucursal
    if(sucursales.trim()===""){
      alert("Ingrese Nombre de Sucursal");
      return;
    }
    if(Number(id_sucursal)>0){

    }else{
      return
    }
    /********************************************/
    var obj = { accion:'grabarsucursal', token,sucursales,ruc,direccion,telefono,activo,hora_apertura_1,
        hora_apertura_2,hora_apertura_3,hora_apertura_4,hora_apertura_5,hora_apertura_6,hora_apertura_7,
        hora_cierre_1,hora_cierre_2,hora_cierre_3,hora_cierre_4,hora_cierre_5,hora_cierre_6,hora_cierre_7,
        hora_apertura_1_2,
            hora_apertura_2_2,hora_apertura_3_2,hora_apertura_4_2,hora_apertura_5_2,hora_apertura_6_2,hora_apertura_7_2,
            hora_cierre_1_2,hora_cierre_2_2,hora_cierre_3_2,hora_cierre_4_2,hora_cierre_5_2,hora_cierre_6_2,hora_cierre_7_2,
        tiempo_aproximado,precio_delivery,id_tipo_precio,distancia,id_sucursal,uuid_sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
      }
      this.props.get_loading(false)
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  inputChangedHandlerText1 = (event) => {
    this.setState({
      sucursales :event.target.value
    })
  }
  inputChangedHandlerText2 = (event) => {
    this.setState({
      ruc :event.target.value
    })
  }
  inputChangedHandlerText3 = (event) => {
    this.setState({
      direccion :event.target.value
    })
  }
  inputChangedHandlerText4 = (event) => {
    this.setState({
      telefono :event.target.value
    })
  }
  inputChangedHandlerText5 = (event) => {
    this.setState({
      precio_delivery :event.target.value
    })
  }
  inputChangedHandlerText6 = (event) => {
    this.setState({
      tiempo_aproximado :event.target.value
    })
  }
  inputChangedHandlerText7 = (event) => {
    this.setState({
      distancia :event.target.value
    })
  }



  inputChangedHandlerText8 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_1 :time
    })
  }
  inputChangedHandlerText9 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_2 :time
    })
  }
  inputChangedHandlerText10 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_3 :time
    })
  }
  inputChangedHandlerText11 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_4 :time
    })
  }
  inputChangedHandlerText12 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_5 :time
    })
  }
  inputChangedHandlerText13 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_6 :time
    })
  }
  inputChangedHandlerText14 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_7 :time
    })
  }

  inputChangedHandlerText15 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_1 :time
    })
  }
  inputChangedHandlerText16 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_2 :time
    })
  }
  inputChangedHandlerText17 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_3 :time
    })
  }
  inputChangedHandlerText18 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_4 :time
    })
  }
  inputChangedHandlerText19 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_5 :time
    })
  }
  inputChangedHandlerText20 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_6 :time
    })
  }
  inputChangedHandlerText21 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_7 :time
    })
  }




  inputChangedHandlerText8_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_1_2 :time
    })
  }
  inputChangedHandlerText9_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_2_2 :time
    })
  }
  inputChangedHandlerText10_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_3_2 :time
    })
  }
  inputChangedHandlerText11_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_4_2 :time
    })
  }
  inputChangedHandlerText12_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_5_2 :time
    })
  }
  inputChangedHandlerText13_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_6_2 :time
    })
  }
  inputChangedHandlerText14_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_apertura_7_2 :time
    })
  }

  inputChangedHandlerText15_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_1_2 :time
    })
  }
  inputChangedHandlerText16_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_2_2 :time
    })
  }
  inputChangedHandlerText17_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_3_2 :time
    })
  }
  inputChangedHandlerText18_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_4_2 :time
    })
  }
  inputChangedHandlerText19_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_5_2 :time
    })
  }
  inputChangedHandlerText20_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_6_2 :time
    })
  }
  inputChangedHandlerText21_2 = (event,value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    this.setState({
      hora_cierre_7_2 :time
    })
  }










  inputChangedHandlerText22 = (event) => {
    this.setState({
      id_tipo_precio : event.target.value
    })
  }
  inputChangedHandlerText23 = (event) => {
    this.setState({
      estado_activo : event.target.checked
    })
   }

  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  render() {
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    //const file_250x200 =this.props.file_250x200
    const file_500x200 =this.props.file_500x200
    //const token_image250x200 = url_image+file_250x200+separator
    const token_image500x200 = url_image+file_500x200+separator
    //const ext250x200="_250x200.png?alt=media"
    const ext500x200="_500x200.png?alt=media"
    // lat, lon, acivo,id_tipo_precio
    const tipo_precio = this.state.tipo_precio
    return(
      <React.Fragment>
      <div className="div_global_registre_U_datasucursal">
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_"></div>
        </div>
        <div  className="div_global_registre_title_U_datasucursal" >
          <span className="span-global-title">Configuración Surcursal</span>
        </div>
        <div className="grid-container-registre_U_datasucursal">
          <div className="div_2_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Nombre Sucursal
          </div>
          <div className="div_2_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.sucursales}
          onChange={(event)=>this.inputChangedHandlerText1(event)} className="input-global" placeholder="Nombre Sucursal" /></div>


          <div className="div_3_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            RUC
          </div>
          <div className="div_3_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.ruc}
          onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global" placeholder="RUC" /></div>


          <div className="div_4_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Dirección
          </div>
          <div className="div_4_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.direccion}
          onChange={(event)=>this.inputChangedHandlerText3(event)} className="input-global" placeholder="Dirección" /></div>


          <div className="div_5_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Teléfono
          </div>
          <div className="div_5_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.telefono}
          onChange={(event)=>this.inputChangedHandlerText4(event)} className="input-global" placeholder="Teléfono" /></div>


          <div className="div_6_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Precio Delivery
          </div>
          <div className="div_6_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.precio_delivery}
          onChange={(event)=>this.inputChangedHandlerText5(event)} className="input-global" placeholder="Precio Delivery" /></div>


          <div className="div_7_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Tiempo Aproximado
          </div>
          <div className="div_7_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.tiempo_aproximado}
          onChange={(event)=>this.inputChangedHandlerText6(event)} className="input-global" placeholder="Tiempo Aproximado" /> Minutos</div>


          <div className="div_8_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Distancia Aproximada
          </div>
          <div className="div_8_2_U_datasucursal"><input style={{"width":"100%"}} value={this.state.distancia}
          onChange={(event)=>this.inputChangedHandlerText7(event)} className="input-global" placeholder="Distancia Aproximada" /> Kilómetros</div>


          <div className="div_9_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Hora de Atención
          </div>
          <div className="div_9_2_U_datasucursal">
            <div className="grid-container-timer">
            <div className="lbl_sinlabel"></div>
            <div className="lbl_apertura">Hora de Apertura</div>
            <div className="lbl_cierre">Hora de Cierre</div>
            <div className="lbl_apertura_b2">Hora de Apertura</div>
            <div className="lbl_cierre_b2">Hora de Cierre</div>

            <div className="lbl_apertura_1">
              <TimeField
                  value={this.state.hora_apertura_1}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText8}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_2">
              <TimeField
                  value={this.state.hora_apertura_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText9}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_3">
              <TimeField
                  value={this.state.hora_apertura_3}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText10}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_4">
              <TimeField
                  value={this.state.hora_apertura_4}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText11}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_5">
              <TimeField
                  value={this.state.hora_apertura_5}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText12}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_6">
              <TimeField
                  value={this.state.hora_apertura_6}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText13}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_7">
              <TimeField
                  value={this.state.hora_apertura_7}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText14}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_1">
              <TimeField
                  value={this.state.hora_cierre_1}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText15}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_2">
              <TimeField
                  value={this.state.hora_cierre_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText16}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_3">
              <TimeField
                  value={this.state.hora_cierre_3}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText17}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_4">
              <TimeField
                  value={this.state.hora_cierre_4}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText18}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_5">
              <TimeField
                  value={this.state.hora_cierre_5}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText19}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_6">
              <TimeField
                  value={this.state.hora_cierre_6}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText20}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_7">
              <TimeField
                  value={this.state.hora_cierre_7}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText21}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>

            <div className="lbl_apertura_1_2">
              <TimeField
                  value={this.state.hora_apertura_1_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText8_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_2_2">
              <TimeField
                  value={this.state.hora_apertura_2_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText9_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_3_2">
              <TimeField
                  value={this.state.hora_apertura_3_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText10_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_4_2">
              <TimeField
                  value={this.state.hora_apertura_4_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText11_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_5_2">
              <TimeField
                  value={this.state.hora_apertura_5_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText12_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_6_2">
              <TimeField
                  value={this.state.hora_apertura_6_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText13_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_apertura_7_2">
              <TimeField
                  value={this.state.hora_apertura_7_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText14_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_1_2">
              <TimeField
                  value={this.state.hora_cierre_1_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText15_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_2_2">
              <TimeField
                  value={this.state.hora_cierre_2_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText16_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_3_2">
              <TimeField
                  value={this.state.hora_cierre_3_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText17_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_4_2">
              <TimeField
                  value={this.state.hora_cierre_4_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText18_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_5_2">
              <TimeField
                  value={this.state.hora_cierre_5_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText19_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_6_2">
              <TimeField
                  value={this.state.hora_cierre_6_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText20_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>
            <div className="lbl_cierre_7_2">
              <TimeField
                  value={this.state.hora_cierre_7_2}                     // {String}   required, format '00:00' or '00:00:00'
                  onChange={this.inputChangedHandlerText21_2}
                  colon=":"                        // {String}   default: ":"                  // {Boolean}  default: false
              />
            </div>


            <div className="lbl_name_1_2">Lunes</div>
            <div className="lbl_name_2_2">Martes</div>
            <div className="lbl_name_3_2">Miércoles</div>
            <div className="lbl_name_4_2">Jueves</div>
            <div className="lbl_name_5_2">Viernes</div>
            <div className="lbl_name_6_2">Sábado</div>
            <div className="lbl_name_7_2">Domingo</div>




            </div>
          </div>

          <div className="div_10_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Tipo de Precio
          </div>
          <div className="div_10_2_U_datasucursal">
            <select className="select-css_global" value={this.state.id_tipo_precio} onChange={this.inputChangedHandlerText22}>
            {(tipo_precio.length !== 0) ?
              tipo_precio.map(tipo_precio => (
                <option key={tipo_precio.id_tipo_precio} value={tipo_precio.id_tipo_precio} >{tipo_precio.tipo_precio}</option>
              ))
              : <React.Fragment></React.Fragment>
            }
          </select>
          </div>
          <div className="div_11_1_U_datasucursal">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            Sucursal Activa
          </div>
          <div className="div_11_2_U_datasucursal">
            <Checkbox
              checked={this.state.estado_activo}
              onChange={this.inputChangedHandlerText23}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </div>
          <div className="div_12_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_12_2_U_dataempresa" >

            <GetUploadImage uuid={1} file_xxx={this.props.file_500x200}  firebase={this.props.firebase} getUUID={this.getUUIDS}
            width={'500px'} height={'200px'} pref={'_500x200'}  token_image={
              (this.state.uuid_sucursal)?
              token_image500x200+this.state.uuid_sucursal+ext500x200:''
            } />
          </div>


        </div>
        <div  className="div_global_registre_title_U_datasucursal" >
          <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getGrabarInformacion()}>
            GRABAR INFORMACIÓN
          </button>
        </div>
      </div>
      </React.Fragment>
    )
  }
  //cargar_informacion
  componentDidMount (){
    this.cargar_informacion()
  }

}
export default getConfiguracionGlobal;
